import router from "./router";
import { getToken, removeToken } from "@/utils/auth";
import { corpId } from "@/utils/config";
import { homeUrl } from "@/request/request";
import * as dd from "dingtalk-jsapi";
import store from "./store";
import UrlEncode from "urlencode";
const whiteList = ["/login", "/cleanToken"]; // 不重定向白名单

router.beforeEach((to, from, next) => {
  store.commit("SET_ROUTENOW", to);
  console.log(to);
  if (to.path == "/cleanToken") {
    removeToken();
    next({ path: "/home" });
  } else {
    if (to.name == "messageUrl") {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == "micromessenger") {
        next(false);
        window.location.href = to.query.mobile;
      } else {
        if (dd.env.platform !== "notInDingTalk") {
          dd.device.base.getPhoneInfo({
            onSuccess: function(data) {
              next(false);
              window.location.href =
                to.query.mobile + "&corpId=" + to.query.corpId;
            },
            onFail: function(err) {
              dd.ready(function() {
                dd.runtime.permission.requestAuthCode({
                  corpId: to.query.corpId,
                  onSuccess: function(result) {
                    next(false);
                    window.location.href =
                      to.query.pc + "&authCode=" + result.code;
                    // dd.biz.util.openLink({
                    //   url: window.location.protocol+"//"+window.location.host+"/#/login?authCode=" + result.code,//要打开链接的地址
                    //   onSuccess: function (result) {
                    //     next({path: '/empty'})
                    //   },
                    //   onFail: function (err) {
                    //   }
                    // });
                  },
                  onFail: function(err) {}
                });
              });
            }
          });
        } else {
          next(false);
          window.location.href = to.query.pc;
        }
      }
    } else {
      if (getToken()) {
        if (to.path === "/login") {
          next({ path: "/" });
          // NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
        } else {
          if (!store.state.menusOver) {
            store
              .dispatch("GetUserMenus")
              .then(res => {
                // 拉取user_info
                next();
              })
              .catch(err => {
                removeToken();
                dd.ready(function() {
                  dd.runtime.permission.requestAuthCode({
                    corpId: to.query.corpId, // 企业id
                    onSuccess: function(info) {
                      var code = info.code; // 通过该免登授权码可以获取用户身份
                      store
                        .dispatch("dingLogin", code)
                        .then(() => {
                          store
                            .dispatch("GetUserMenus")
                            .then(res => {
                              // 拉取user_info
                              next();
                            })
                            .catch(err => {
                              removeToken();
                              next();
                            });
                        })
                        .catch(() => {
                          removeToken();
                          next();
                        });
                    }
                  });
                });
              });
          } else {
            next();
          }
        }
      } else {
        if (dd.env.platform !== "notInDingTalk") {
          dd.ready(function() {
            dd.runtime.permission.requestAuthCode({
              corpId: to.query.corpId, // 企业id
              onSuccess: function(info) {
                var code = info.code; // 通过该免登授权码可以获取用户身份
                store
                  .dispatch("dingLogin", code)
                  .then(() => {
                    store
                      .dispatch("GetUserMenus")
                      .then(res => {
                        // 拉取user_info
                        next();
                      })
                      .catch(err => {
                        removeToken();
                      });
                  })
                  .catch(() => {
                    removeToken();
                  });
              },
              onFail: function(err) {}
            });
          });
        } else {
          if (whiteList.indexOf(to.path) !== -1) {
            next();
          } else {
            const unionid = localStorage.getItem("unionid"); //|| 'onwl9t4pstpw2W3hkAfuWKHcRzaY'
            // const unionid = 'obaFZ0ugDFZvU51m3RCrdaGJGtuw';//|| 'onwl9t4pstpw2W3hkAfuWKHcRzaY'
            if (unionid) {
              to.query.unionId = unionid;
            } else if (to.query.code && to.query.state) {
              store
                .dispatch("loadWxUnionId", to.query.code)
                .then(res => {
                  console.log(res);
                  if (res.token) {
                    store
                      .dispatch("GetUserMenus")
                      .then(res => {
                        // 拉取user_info
                        next();
                      })
                      .catch(err => {
                        removeToken();
                      });
                  } else {
                    store.commit("SET_HISTORY", to);
                    next({ name: "login", query: { openId: res.openId } });
                  }
                })
                .catch(err => {});
              // this.loadWxUnionId(query.code);
            } else {
              var localUrl = location.origin;

              if (to.name) {
                var getHomeUrl = localUrl + router.resolve({ ...to }).href;
              } else {
                var getHomeUrl = localUrl + "/home";
              }
              window.location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx884fad7e2cebff9e&redirect_uri=" +
                UrlEncode(getHomeUrl) +
                "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
            }
          }
        }
      }
    }
  }
});

router.afterEach(() => {
  // NProgress.done() // 结束Progress
});



// WEBPACK FOOTER //
// ./src/permission.js